export enum PaymentType {
  IB_CREDIT = 'IB_CREDIT',
  PREPAID = 'PREPAID',
  COD = 'COD',
  PART_PAY = 'PART_PAY',
  COMPLETE_COD = 'COMPLETE_COD',
  NEFT = 'NEFT',
}

export enum PaymentPageType {
  POPUP = 'POPUP',
  REDIRECT = 'REDIRECT',
}
